module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mainLoading),
      expression: "mainLoading"
    }],
    staticClass: "flow no-select"
  }, [_c('node-paper', {
    ref: "nodePaper",
    attrs: {
      "width": "calc(100% - 450px)",
      "height": _vm.height,
      "nodeList": _vm.nodeList,
      "routeList": _vm.routeList,
      "inputList": _vm.inputList,
      "curNode": _vm.curNode,
      "curRoute": _vm.curRoute,
      "nodeIden": _vm.nodeIden,
      "inputType": _vm.inputType,
      "inputTitle": _vm.inputTitle
    },
    on: {
      "modifyNodeList": _vm.modifyNodeList,
      "setCurNode": _vm.setCurNode,
      "setNodeIden": _vm.setNodeIden,
      "getRelateNode": _vm.getRelateNode,
      "setCurNodeField": _vm.setCurNodeField,
      "setCudShow": _vm.setCudShow,
      "setInputShow": _vm.setInputShow,
      "setCurRoute": _vm.setCurRoute
    }
  }), _vm._v(" "), _vm._v(" "), _c('node-config', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curRoute.start_iden === undefined),
      expression: "curRoute.start_iden === undefined"
    }],
    ref: "nodeConfig",
    attrs: {
      "height": _vm.height,
      "width": "450px",
      "curNode": _vm.curNode,
      "nodeList": _vm.nodeList,
      "routeList": _vm.routeList,
      "inputList": _vm.inputList,
      "users": _vm.users,
      "structs": _vm.structs,
      "groups": _vm.groups,
      "posts": _vm.posts
    }
  }), _vm._v(" "), _c('route-config', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curRoute.start_iden !== undefined),
      expression: "curRoute.start_iden !== undefined"
    }],
    attrs: {
      "curRoute": _vm.curRoute,
      "height": _vm.height,
      "width": "450px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('input-list', {
    ref: "inputList",
    attrs: {
      "inputList": _vm.tempInputList
    },
    on: {
      "setNewInputList": _vm.setNewInputList,
      "openDepentConfig": _vm.openDepentConfig,
      "setKeyDepent": _vm.setKeyDepent,
      "confirmDepentConfig": _vm.confirmDepentConfig
    }
  }), _vm._v(" "), _c('depent-config', {
    ref: "depentConfig",
    attrs: {
      "keyDepent": _vm.keyDepent,
      "showName": _vm.showName
    }
  }), _vm._v(" "), _c('input-config', {
    ref: "inputConfig",
    attrs: {
      "inputList": _vm.inputList,
      "curNode": _vm.curNode,
      "curGroupIds": _vm.curGroupIds,
      "inputTitle": _vm.inputTitle,
      "inputType": _vm.inputType,
      "isFullInputData": false,
      "needCondition": false,
      "modifyNode": _vm.modifyNode,
      "showConfig": _vm.showConfig
    },
    on: {
      "setInputShow": _vm.setInputShow,
      "setInputListShow": _vm.setInputListShow,
      "confirmCurField": _vm.confirmCurField,
      "resetTempInputList": _vm.resetTempInputList,
      "setCurGroupIds": _vm.setCurGroupIds
    }
  }), _vm._v(" "), _c('cud-config', {
    ref: "cudConfig",
    attrs: {
      "modelId": _vm.modelId,
      "cudConfig": _vm.curNode.cud_config
    },
    on: {
      "setCudConfig": _vm.setCudConfig
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fl m-t-10"
  }, [_c('el-button', {
    on: {
      "click": _vm.importData
    }
  }, [_vm._v("导入数据")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出数据")])]), _vm._v(" "), _c('div', {
    staticClass: "tx-c m-t-10"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "importFile",
      "type": "file"
    },
    on: {
      "change": _vm.importFileChange
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "exportData",
      "href": "#",
      "download": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71b75f6d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/design.vue
// module id = 1917
// module chunks = 2